import classnames from "classnames";
import { FEEDBACK_TEXT, FEEDBACK_STATES } from "./constants";
import getAccessToken from "shared/util/getAccessToken";

import * as PhotoUpload from "shared/util/PhotoUpload";

export function getImageSource(images) {
	let biggestWidth = 0;
	const biggest = images.reduce((memo, image) => {
		if (image.width > biggestWidth && image) {
			biggestWidth = image.width;
			return image;
		}

		return memo;
	}, {});
	const { source } = biggest;
	return source;
}

export function insertDraggingPhoto({ draggingPhotoId, newIndex, photos }) {
	const draggingPhotoIndex = photos.indexOf(draggingPhotoId);

	// handle the no-swap sitch
	if (photos[newIndex] === undefined || draggingPhotoIndex === -1) {
		return photos;
	}

	// make a new array since splice is a fucker that mutates the array
	const newPhotos = [];

	// use a while loop here
	// (if we used foreach, we wouldn't be able to replace the last element)
	// [which we could do by using two checks, but fuck that]
	let i = -1;

	/* eslint-disable */
	while (newPhotos.length !== photos.length) {
		// roll up
		i++;

		const id = photos[i];

		// ignore the dragging photo
		if (id === draggingPhotoId) {
			continue;
		}

		// if the draggingPhoto is up, go ahead naw
		if (newPhotos.length === newIndex) {
			newPhotos.push(draggingPhotoId);
		}

		// push this sucker on (if sucker)
		if (id !== null && id !== undefined) {
			newPhotos.push(id);
		}
	}
	/* eslint-enable */

	return newPhotos;
}

export function getPhotoClasses(index, isPreview) {
	const nth = index + 1;
	return classnames({
		"photoOrganizer-photo": true,
		"photoOrganizer-photo--primary": nth === 1,
		"photoOrganizer-photo--topright": nth === 2,
		"photoOrganizer-photo--middle": nth >= 5 && (nth - 5) % 3 === 0,
		"photoOrganizer-photo--preview": isPreview,
	});
}

function _rand(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

export function getFeedback({ state, error, photoCount }) {
	let text;

	if (!state) {
		text = FEEDBACK_TEXT.start;
	}

	if (state === FEEDBACK_STATES.error) {
		text = error;
	} else if (state === FEEDBACK_STATES.complete) {
		text = FEEDBACK_TEXT.complete;
	} else if (state === FEEDBACK_STATES.adding) {
		text = FEEDBACK_TEXT.adding;
	} else if (state === FEEDBACK_STATES.deleting) {
		if (photoCount && photoCount > 2) {
			text = FEEDBACK_TEXT.deleting;
		} else {
			text = FEEDBACK_TEXT.tooLow;
		}
	} else {
		text = FEEDBACK_TEXT.start;
	}

	if (text instanceof Array) {
		return _rand(text);
	} else {
		return text;
	}
}

// upload a photo from Facebook, add its crop information, then return the picid
export function uploadFacebookPhotoAndDetails(userid, source) {
	return PhotoUpload.uploadPhotoURL(source, userid)
		.then((res) => {
			const {
				id, picid, width, height,
			} = res;

			if (!id && !picid) {
				return Promise.reject({
					error: `
						uploadPhotoDetails: no id/picid from ${userid} and
						${source} and ${JSON.stringify(res)}
					`,
				});
			}

			return PhotoUpload.uploadPhotoDetails({
				userid,
				authcode: getAccessToken(),
				picid: id || picid,
				width,
				height,
				cropInfo: {
					topLeftX: 0,
					topLeftY: 0,
					bottomRightX: width,
					bottomRightY: width,
				},
			});
		});
}



// WEBPACK FOOTER //
// ./src/apps/photo_organizer/util/helpers.js